import React from "react";
import useSessionStorage from "./useSessionStorage";

const RequiresAdmin = ({ children }) => {
  const [token] = useSessionStorage("token", null);

  if (!token) {
    return <div>Authentication required</div>;
  }

  // Decode JWT token to get user_type
  let userType = "user"; // Default
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    userType = payload.user_type || "user";
  } catch (error) {
    console.error("Error decoding token:", error);
  }

  if (userType !== "admin") {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '50vh',
        textAlign: 'center',
        padding: '20px'
      }}>
        <h2 style={{ color: '#dc3545', marginBottom: '20px' }}>Access Denied</h2>
        <p style={{ fontSize: '18px', color: '#6c757d', maxWidth: '400px' }}>
          You do not have permission to access this section. 
          This area is restricted to administrators only.
        </p>
        <p style={{ fontSize: '14px', color: '#6c757d', marginTop: '20px' }}>
          If you believe you should have access, please contact your administrator.
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default RequiresAdmin;